import { composeFieldPath } from '@northfork/basics'

export interface AccountSummary {
  associatedAccounts: number[]
  issueStatusAccounts: Map<string, number[]>
  allIssueAccounts: number[]
  forRemoval: boolean
}

export interface AccountSummaryModel {
  property: string
  value: string
}
export const accountSummaryModelField = composeFieldPath(
  [] as AccountSummaryModel[],
)

export enum AccountSummaryModelPropertyField {
  ASSOCIATED = 'Associated',
  WITHISSUES = 'With Issues',
  ISSUESTATUSACCOUNTS = 'issueStatusAccounts',
}

export enum AccountSummaryModelValueField {
  ASSOCIATEDACCOUNTS = 'associatedAccounts',
  ALLISSUEACCOUNTS = 'allIssueAccounts',
  ISSUESTATUSACCOUNTS = 'issueStatusAccounts',
}
export const accountSummaryModelFieldMap = new Map<string, string>([
  [
    AccountSummaryModelValueField.ASSOCIATEDACCOUNTS,
    AccountSummaryModelPropertyField.ASSOCIATED,
  ],
  [
    AccountSummaryModelValueField.ALLISSUEACCOUNTS,
    AccountSummaryModelPropertyField.WITHISSUES,
  ],
  [
    AccountSummaryModelValueField.ISSUESTATUSACCOUNTS,
    AccountSummaryModelPropertyField.ISSUESTATUSACCOUNTS,
  ],
])
